import type { GlobalThemeOverrides } from 'naive-ui'

/** Admin Naive UI theme — primary #0085db */
export const adminThemeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#0085db',
    primaryColorHover: '#1a97e8',
    primaryColorPressed: '#006db4',
    primaryColorSuppl: '#1a97e8',
  },
  LoadingBar: {
    colorLoading: '#0085db',
    colorError: '#e11d48',
    height: '3px',
  },
}
